
// import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { Ripple } from "primereact/ripple";
// import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/bootstrap.css";
import { useHistory } from "react-router-dom";
import InputText from "../other/InputText";
// import CustomerFileUpload from "./customerFileUpload";
// import { InputMask } from "primereact/inputmask";
import ViewConflictData from "./viewConlictData";
// import { Checkbox } from "primereact/checkbox";
import ApiService from "../service/apiService";

const boAcctStatus = ['Status Unknown', 'Active', 'To be closed', 'Closed', 'Request for closed initiated by DP', 'Pending for activation']

export const getBoAccountStatusDesc = (status) => boAcctStatus[status || 0];

const statusList = [
  {
    code: "A",
    label: "All",
  },
  {
    code: "P",
    label: "Pending",
  },
  {
    code: "I",
    label: "Initiated",
  },
  {
    code: "PR",
    label: "Processing",
  },
  {
    code: "V",
    label: "Verified",
  },
];

function KycBoidModel(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const [page, setPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const [kycList, setKycList] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentPage = page;
  const pageInputTooltip = "Input page no";
  const onPageInputKeyDown = () => true;
  const onPageInputChange = () => true;

  const [phrase, setPhrase] = useState();
  const [dupPerc, setDupPerc] = useState(100);
  const [allDp, setAllDp] = useState(false);
  const [citizenshipNo, setCitizenshipNo] = useState();
  const [boid, setBoid] = useState();
  const [mobileNo, setMobileNo] = useState();
  const [tempKycId, setTempKycId] = useState();
  const [permKycId, setPermKycId] = useState();
  const [totalElements, setTotalElements] = useState();
  const [dialog, setDialog] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [viewConflictDialog, setViewConflicDialog] = useState(false);
  const [rowData, setRowData] = useState();
  const [districtList, setDistrictList] = useState();
  useEffect(() => {
    ApiService.getDistrictList().then((response) => {
      setDistrictList(response.data.data);
    });
  }, [])

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  const getCitzenshipDetail = (c23, c19, c15) => {
    const data = c23 || c19 || c15;
    if (!data) return '';
    const list = [(c23 || c19) && data.substring(0, 4),
    data.substring((c23 || c19) ? 4 : 0, (c23) ? data.length - 4 : data.length),
    c23 && data.substring(data.length - 4, data.length)];
    list[0] = list.length && list[0] && getDescription(districtList, list[0]);
    return list.filter(d => d).join("-");
  }


  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getKycPage = (page, size) => {
    setLoading(true);
    ApiService
      .getConflictingData(
        {
          searchParam: phrase || null,
          percentageFlag: !dupPerc ? null : dupPerc,
          allDp: allDp
        },
        page,
        size
      )
      .then((response) => {
        // console.log(response.data.content, "response.data.content");
        setKycList(response.data.data.content.map(data => {
          return {
            custName: data.custName,
            fatherName: data.fatherName,
            grandFatherName: data.grandFatherName,
            email: data.email || '',
            mobileNo: data.mobile || '',
            ctznNo: getCitzenshipDetail(data.ctznNo23, data.ctzn19, data.ctzn15),
            dob: data.dob,
            matchBoid: data.duplicate100,
            ...data,
          };
        }));
        setTotalElements(response.data.data.totalElements);
        setTotalPages(response.data.data.totalPages);
      }).finally(() => {
        setLoading(false);
      })
  };

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "vertical",
    tableBodyMaxHeight: "",
    selectToolbarPlacement: "none",
    serverSide: true,
    totalElements: totalElements,
    serverSide: true,
    tableBodyMaxHeight: '400px',
    // selectableRows: false,
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: true,
    count: totalElements,
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          getKycPage(tableState.page, tableState.rowsPerPage);
          break;
        case "changeRowsPerPage":
          getKycPage(tableState.page, tableState.rowsPerPage);
          break;
        default:
          console.log("default block");
      }

      return false;
    },
    onRowSelectionChange: (currentSelect, allSelected) => {
      const result = allSelected.map((item) => {
        return kycList.at(item.index);
      });
      setSelectedRowData(result);
    },
  };

  const columns = [
    {
      name: "boId",
      label: "BO ID",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <a href="#"
                onClick={() => {
                  console.log(tableMeta.rowData);
                  setRowData(tableMeta.rowData);
                  setViewConflicDialog(1);
                }}>{value}</a>
            </>
          )
        }
      },
    },
    {
      name: "custName",
      label: "Customer Name",
      options: {},
    },
    {
      name: "fatherName",
      label: "Father Name",
      options: {},
    },
    {
      name: "grandFatherName",
      label: "Grand Father Name",
      options: {},
    },
    {
      name: "ctznNo",
      label: "Citizenship No",
      options: {}
    },
    {
      name: "birthCertificateNo",
      label: "Birth Certificate No",
      options: {}
    },
    {
      name: "email",
      label: "Email",
      options: {},
    },
    {
      name: "mobileNo",
      label: "Mobile No",
      options: {},
    },
    {
      name: "dob",
      label: "Date of Birth/Incorporation",
      options: {},
    },
    {
      name: "pan",
      label: "PAN",
      options: {},
    },
    {
      name: "regNo",
      label: "Reg No",
      options: {},
    },
    {
      name: "acctSts",
      label: "BO Status",
      options: { customBodyRender: getBoAccountStatusDesc },
    },
    {
      name: "matchBoid",
      label: "100% Match",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <a href="#"
                onClick={() => {
                  console.log(tableMeta.rowData);
                  setRowData(tableMeta.rowData);
                  setViewConflicDialog(2);
                }}>{value}</a>
            </>
          )
        }
      },
    },
    {
      name: "duplicate90",
      label: "90% Match",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <a href="#"
                onClick={() => {
                  console.log(tableMeta.rowData);
                  setRowData(tableMeta.rowData);
                  setViewConflicDialog(3);
                }}>{value}</a>
            </>
          )
        }
      },
    }

  ];

  const template1 = {
    layout:
      "PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport",
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-p-3">Next</span>
          <Ripple />
        </button>
      );
    },
    PageLinks: (options) => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(options.className, { "p-disabled": true });

        return (
          <span className={className} style={{ userSelect: "none" }}>
            ...
          </span>
        );
      }

      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: "All", value: options.totalRecords },
      ];

      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
        />
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          className="p-mx-3"
          style={{ color: "var(--text-color)", userSelect: "none" }}
        >
          Go to{" "}
          <InputText
            size="2"
            className="p-ml-1"
            value={currentPage}
            tooltip={pageInputTooltip}
            onKeyDown={(e) => onPageInputKeyDown(e, options)}
            onChange={onPageInputChange}
          />
        </span>
      );
    },
  };
  const [showModel, setShowModel] = useState();

  return (
    <Dialog
      header={"KYC BOID Search"}
      visible={props.visible}
      style={{ width: "100%", height: "750px" }}
      footer={
        <>
          <Button
            icon="pi pi-check"
            label="Import"
            onClick={() => {
              props.onChange(selectedRowData, dupPerc);
              props.onHide();
            }}
          />
        </>
      }
      onHide={props.onHide}
    >
      <div className="p-grid p-fluid">
        <div
          className="p-grid p-col-12 p-md-12"
          style={{ border: "1px solid #edebef", borderRadius: 16 }}
        >
          <div className="p-field p-col-12 p-md-4 stick-right">
            <label className="p-col-12 p-md-12" htmlFor="type">
              Analysis
            </label>
            <Dropdown
              value={dupPerc}
              onChange={(e) => {
                setDupPerc(e.value);
              }}
              options={[{ code: 100, desc: "100% duplicate" }, { code: 0, desc: "All Boid" }]}
              optionLabel="desc"
              placeholder={t("selectType")}
              optionValue="code"
            />
          </div>

          <div className="p-field p-col-12 p-md-8 stick-left">
            <label className="p-col-12 p-md-12" htmlFor="code">
              Search Phrase
            </label>
            <InputText
              autoFocus
              keyfilter={/^[a-zA-Z0-9\.\,\\\(\) ]*$/}
              placeholder={t("Phrase")}
              onChange={(e) => {
                setPhrase(e.target.value);
              }}
              value={phrase}
            />
          </div>

          <div className="p-col-12 p-md-10"></div>
          <div className="p-col-12 p-md-2">
            <Button
              style={{ borderRadius: "19px" }}
              className="p-col-3"
              label={"Search"}
              loading={loading}
              onClick={(e) => {
                getKycPage();
              }}
            />
          </div>
        </div>
        <div
          style={{
            border: "1px solid #edebef",
            marginTop: 10,
            borderRadius: 16,
            width: "100%",
          }}
        >
          <div
            className="p-field p-col-12 p-md-12"
            style={{ width: "100%", padding: "0px 17px" }}
          >
            {/* <ThemeProvider theme={createTheme()}> */}
            <MUIDataTable
              data={kycList}
              columns={columns}
              options={options}
              style={{ height: 'none' }}
            />
            {/* </ThemeProvider> */}
          </div>
          {/* {dialog ? <CustomerFileUpload customerId={customerId} visible={dialog} onHide={() => setDialog(false)} /> : null} */}
          {viewConflictDialog ? (
            <ViewConflictData
              visible={viewConflictDialog}
              onHide={() => setViewConflicDialog(false)}
              mainBoId={rowData[0]}
              boids={[rowData[0], viewConflictDialog !== 3 && rowData[12], viewConflictDialog !== 2 && rowData[13]].filter(dd => dd).join(',')}
            />
          ) : null}
        </div>
      </div>
    </Dialog>
  );
}
export default KycBoidModel;
